module.exports = __webpack_public_path__ + "images/emoji/seat.2ac8be4ec64cbdfec7df.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/seat.png
// module id = fILw
// module chunks = 13